import { HttpHeader } from '../../constants';
import { IframeFileReadableStream } from '../../stream';

/**
 * Endpoint Stream integration layer (`src/endpoint/stream`)
 *
 * This directory integrates postMessage `stream_*` messages with the stream object system in `src/stream`:
 * - Endpoint-side file stream utilities (e.g. choose filename from header/metadata and auto-resolve)
 * - Does NOT implement the stream protocol itself (protocol lives in `src/stream`)
 *
 * Parse filename from Content-Disposition header.
 */
export function parseFilenameFromContentDisposition(value) {
  return IframeFileReadableStream.parseFilenameFromContentDisposition(value);
}

/**
 * Auto resolve a file readable stream to File/Blob.
 *
 * Filename priority:
 * - Content-Disposition filename (if provided)
 * - stream_start metadata filename (if provided)
 * - stream.filename (if provided)
 */
export function autoResolveIframeFileReadableStream(params) {
  var _params$headers, _params$info;
  var headerFilename = parseFilenameFromContentDisposition((_params$headers = params.headers) === null || _params$headers === void 0 ? void 0 : _params$headers[HttpHeader.CONTENT_DISPOSITION]);
  var fileName = headerFilename || ((_params$info = params.info) === null || _params$info === void 0 || (_params$info = _params$info.metadata) === null || _params$info === void 0 ? void 0 : _params$info.filename) || params.fileStream.filename;
  var anyStream = params.fileStream;
  if (typeof anyStream.readAsFileOrBlob === 'function') {
    return anyStream.readAsFileOrBlob(fileName);
  }
  // Backward-compatible fallback for mocks/older stream objects
  return fileName ? anyStream.readAsFile(fileName) : anyStream.readAsBlob();
}